import { Monitor } from 'lucide-react'

export function MobileBlockedFallback() {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <Monitor className="w-16 h-16" />
      <h2 className="text-xl md:text-2xl font-semibold mt-4">
        PC에서 이용해주세요.
      </h2>
      <p className="text-sm text-grayscale-60 mt-2">
        이 페이지는 PC 환경에서만 이용 가능합니다.
      </p>
    </div>
  )
}
